import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";

function SubjectsByExamSectionDropDown(props) {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [Subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(false);

  const sectionId = parseInt(props.Section_Id, 10) || 0;
  const examId = parseInt(props.ExamID, 10) || 0;

  useEffect(() => {
    if (sectionId <= 0 || examId <= 0) {
      setSubjects([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType || "Admin",
      Section_Id: sectionId,
      ExamID: examId,
    };

    axios({
      method: "post",
      url: config.base_url + "Exam/GetSubjectsBySectionIDExamID",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setSubjects(response.data.ListofRecords || []);
        } else {
          setSubjects([]);
        }
        setLoading(false);
      })
      .catch(function () {
        setSubjects([]);
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType, sectionId, examId]);

  if (loading) {
    return <option value="" disabled>Loading...</option>;
  }

  if (Subjects.length === 0) {
    return <option value="" disabled>No subjects configured</option>;
  }

  return Subjects.map((item, index) => (
    <option value={item.ID} key={index}>
      {item.Name}
    </option>
  ));
}

export default SubjectsByExamSectionDropDown;
